import { render, staticRenderFns } from "./WindStats.vue?vue&type=template&id=7578cf12&scoped=true&"
import script from "./WindStats.vue?vue&type=script&lang=js&"
export * from "./WindStats.vue?vue&type=script&lang=js&"
import style0 from "./WindStats.vue?vue&type=style&index=0&id=7578cf12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7578cf12",
  null
  
)

export default component.exports